const applications = Object.freeze({
  Mipe: "E2AB3F04-B958-4755-8A1B-DA0B75920997",
  Parent: "FB7FCF39-0EA8-4106-9157-D9BE1BB99544",
  PublicPortal: "C0F2DBAF-BFC2-4AF1-8687-0F432A9613A7"
});

export default applications;
